module.exports = __webpack_public_path__ + "media/2-72.98e49fa1.wav";